import { render, staticRenderFns } from "./census.vue?vue&type=template&id=3bd2d07e&scoped=true&"
import script from "./census.vue?vue&type=script&lang=js&"
export * from "./census.vue?vue&type=script&lang=js&"
import style0 from "./census.vue?vue&type=style&index=0&id=3bd2d07e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2d07e",
  null
  
)

export default component.exports